import styled from 'styled-components'
import { layout, space, flexbox, typography } from 'styled-system'
import { A } from 'components/generic/HomePageComponents'
import { respondTo } from 'utils/themeUtils'

export const StyledPath = styled.path`
  fill: ${(props) => props.theme.colors.reasonsToHireMeCta};
`
export const StyledSVG = styled.svg`
  ${layout}
`

export const NewBadge = styled.span`
  width: 32px;
  height: 16px;
  font-style: normal;
  font-weight: bold;
  font-size: 10px;
  line-height: 16px;
  display: block;
  align-self: center;
  text-align: center;
  color: ${(props) => props.theme.colors.white};
  background: ${(props) => props.theme.colors.successColor};
  border-radius: 8px;
  margin-right: 4px;
`

export const ReasonCTATitle = styled.div`
  color: ${(props) => props.theme.colors.textColor};
  font-size: 20px;
  font-family: 'Proxima Nova', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-style: normal;
  font-weight: bold;
  padding-bottom: .5rem;
  ${layout}
  ${space}
  ${typography}
`
export const AddAReasonCTAButton = styled(A)`
  cursor: pointer;
  transition: background-color 0.5s ease;
  white-space: normal;
  text-decoration: none;
  border-radius: 5px;
  background-color: ${(props) => props.theme.colors.white};
  color: ${(props) => props.theme.colors.textColor};
  padding: 6px 16px;
  border: 2px solid;
  border-color: ${(props) => props.theme.colors.white};
  display: flex;
  font-family: 'Proxima Nova', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  align-items: center;
  align-self: center;
  justify-content: center;
  text-align: center;
  margin-bottom: 16px;
  :hover {
    background-color: ${(props) => props.theme.colors.secondary};
    color: ${(props) => props.theme.colors.white};
    border: 2px solid ${(props) => props.theme.colors.white};
  }

  ${respondTo.desktop`
    margin-bottom: 0;
    margin-left: auto;
    margin-right: 24px;
  `}
  ${layout}
  ${space}
  ${flexbox}
`

export const ReasonCTATextContainer = styled.div`
  display: block;
  ${layout}
  ${space}
`

export const ReasonCTAContainer = styled.div`
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  background-color: ${(props) => props.theme.colors.reasonsToHireMeCta};
  position: relative;
  text-decoration: none;
  margin-top: 24px;

  ${respondTo.desktop`
    flex-direction: row;
  `}
  ${layout}
  ${space}
`